import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Switch from "react-switch";
import { Eye, EyeOff } from "lucide-react"; // Icônes pour afficher/masquer

import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
  Collapse,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import { makeSelectStyles } from "../../common/selectStyles";
import {
  FiChevronUp,
  FiChevronDown,
  FiEdit3,
  FiEye,
  FiEyeOff,
} from "react-icons/fi";
function NewConfigMessagerie() {
  const [wait, setWait] = useState(1000);
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  let { id } = useParams();
  const navigate = useNavigate();
  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = {
    width: "20em", // Largeur fixe pour la première colonne
    whiteSpace: "wrap", // Empêche le texte de revenir à la ligne
    display: "inline-block", // Permet de conserver le texte sur une seule ligne
    color: "#7f7f7f",
    verticalAlign: "middle", // Alignement vertical au centre pour le texte
    display: "flex", // Utilisation de flexbox pour aligner les éléments horizontalement
    alignItems: "center", // Centrage vertical du texte et de l'input
  };
  const layout = localStorage.getItem("layoutMode");
  const [isIdentificationAccordionOpen, setIsIdentificationAccordionOpen] =
    useState(true);
  const toggleIdentificationAccordion = () => {
    setIsIdentificationAccordionOpen(!isIdentificationAccordionOpen);
  };
  const styles = makeSelectStyles(layout);
  const [loading, setLoading] = useState(true);

  const token = localStorage.getItem("auth_token_" + api);
  const [configData, setConfigData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [showPassword, setShowPassword] = useState(false);
  const [showClientSecret, setShowClientSecret] = useState(false);
  // Variable
  const [formData, setFormData] = useState({
    Utilisateur: "",
    Email: "",
    Adresse: "",
    Domaine: "",
    "Mot de passe": "",
    Port: "",
    "Client ID": "",
    "Tenant ID": "",
    "Client Secret": "",
  });

  // Fonction pour gérer les changements de valeurs
  const handleInputChange = (key, value) => {
    setFormData((prevState) => ({
      ...prevState,
      [key]: value,
    }));
  };

  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };
  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      setLoading(true);

      const response = await fetch(
        `https://www.fluxod.com/${api}/smtp_parametres/`,
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            username: formData.Utilisateur,
            email_associe_au_compte: formData.Email,
            address: formData.Adresse,
            domain: formData.Domaine,
            password: formData["Mot de passe"],
            port: formData.Port,
            client_id: formData["Client ID"],
            tenant_id: formData["Tenant ID"],
            client_secret: formData["Client Secret"],
          }),
        }
      );

      if (response.ok) {
        console.log("PATCH request successful");
        handleNavigate();
      } else {
        console.error("PATCH request failed");
        const responseData = await response.json();

        if (responseData && responseData.smtp_parametre_validation) {
          // Si le champ "contact_validation" est présent dans la réponse JSON
          const errors = responseData?.smtp_parametre_validation;

          errors.forEach((error) => {
            toast.error(error);
          });
        } else {
          toast.error("Une erreur s'est produite");
        }
      }
    } catch (error) {
      console.error("An error occurred", error);
      toast.error("Une erreur s'est produite");
    }
  };
  /******************************* END Validation *******************************************/

  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };
  document.title = "Impression | Edit";
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails Compte de messagerie
          </NavLink>
        </NavItem>
      </Nav>
    );
  };

  return (
    <>
      <React.Fragment>
        <div className="page-content" style={{ fontFamily: "sans-serif" }}>
          <div className="container-fluid">
            <Row>
              <Col lg="12">
                <Card>
                  <CardBody className="border-bottom">
                    <div className="d-flex align-items-center">
                      <h5
                        className="mb-0 card-title flex-grow-1"
                        style={{ fontWeight: "bold", display: "flex" }}
                      >
                        <Link
                          to={`${backUrl}/smtp_parametres/`}
                          style={{
                            color: "#555B21",
                            textDecoration: "underline !important",
                          }}
                        >
                          Compte de messagerie
                        </Link>{" "}
                        <i className="bx bx-caret-right"></i>{" "}
                        {!loading ? (
                          "Nouveau"
                        ) : (
                          <>
                            <span
                              className="placeholder col-3"
                              style={{ height: "1em" }}
                            ></span>
                          </>
                        )}
                      </h5>
                    </div>

                    <div className="d-flex justify-content-end">
                      <div className="d-flex align-items-end">
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={handleSubmit}
                        >
                          <i className="bx bx-send"></i> Valider
                        </button>
                        &nbsp; &nbsp;
                        <Link
                          to="#"
                          onClick={() => navigate(-1)}
                          className="btn btn-sm btn-soft-secondary "
                          style={{ width: "88.43px" }}
                        >
                          <i className="bx bx-arrow-back"></i> Annuler
                        </Link>
                      </div>
                    </div>
                  </CardBody>
                  {CustomNavTabs()}
                  <CardBody>
                    {activeTab === "details" && (
                      <div>
                        {!loading ? (
                          <>
                            <Row>
                              <Col sm="6">
                                <Col>
                                  {formData ? (
                                    <Row>
                                      <Card
                                        className="shadow-sm border-0 overflow-hidden mb-4"
                                        style={{ borderRadius: "12px" }}
                                      >
                                        {/* En-tête cliquable */}
                                        <div
                                          className="px-2 py-2 text-white fw-semibold d-flex align-items-center justify-content-between"
                                          style={{
                                            background: "#555B21",
                                            letterSpacing: "0.5px",
                                            cursor: "pointer",
                                            userSelect: "none",
                                          }}
                                          onClick={
                                            toggleIdentificationAccordion
                                          }
                                        >
                                          <div className="d-flex align-items-center">
                                            <span
                                              style={{ fontSize: "0.82rem" }}
                                            >
                                              Identification
                                            </span>
                                          </div>
                                          {isIdentificationAccordionOpen ? (
                                            <FiChevronUp size={16} />
                                          ) : (
                                            <FiChevronDown size={16} />
                                          )}
                                        </div>

                                        <Collapse
                                          isOpen={isIdentificationAccordionOpen}
                                        >
                                          <CardBody className="p-0">
                                            <div
                                              className="fields-container"
                                              style={{ paddingBottom: "8px" }}
                                            >
                                              {Object.keys(formData).map(
                                                (key) => {
                                                  const isRequired =
                                                    key !== "Client ID" &&
                                                    key !== "Tenant ID" &&
                                                    key !== "Client Secret";
                                                  const isPassword =
                                                    key === "Mot de passe";
                                                  const isClientSecret =
                                                    key === "Client Secret";
                                                  const isPasswordField =
                                                    isPassword ||
                                                    isClientSecret;

                                                  return (
                                                    <div
                                                      key={key}
                                                      className="field-item px-2 py-1 mb-1"
                                                      style={{
                                                        backgroundColor:
                                                          "white",
                                                        transition:
                                                          "all 0.15s ease",
                                                        borderLeft: isRequired
                                                          ? "3px solid #dc3545"
                                                          : "3px solid transparent",

                                                        position: "relative",
                                                        marginBottom: "1px",
                                                      }}
                                                      onMouseEnter={(e) => {
                                                        const isInvalid =
                                                          isRequired;
                                                        if (isInvalid) {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#ffe6e6";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#dc3545";
                                                        } else {
                                                          e.currentTarget.style.backgroundColor =
                                                            "#e3f2fd";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#007bff";
                                                        }
                                                      }}
                                                      onMouseLeave={(e) => {
                                                        const isInvalid =
                                                          isRequired;
                                                        if (isInvalid) {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "#dc3545";
                                                        } else {
                                                          e.currentTarget.style.backgroundColor =
                                                            "white";
                                                          e.currentTarget.style.borderLeftColor =
                                                            "transparent";
                                                        }
                                                      }}
                                                    >
                                                      <Row className="align-items-center g-1">
                                                        <Col xs={12} md={4}>
                                                          <div className="d-flex align-items-center small text-muted">
                                                            <span
                                                              className="fw-medium"
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                letterSpacing:
                                                                  "0.2px",
                                                              }}
                                                            >
                                                              {key}
                                                            </span>
                                                            <span className="ms-1 text-primary">
                                                              :
                                                            </span>
                                                          </div>
                                                        </Col>
                                                        <Col xs={12} md={8}>
                                                          <div className="d-flex align-items-center position-relative">
                                                            <input
                                                              type={
                                                                isPassword
                                                                  ? showPassword
                                                                    ? "text"
                                                                    : "password"
                                                                  : isClientSecret
                                                                  ? showClientSecret
                                                                    ? "text"
                                                                    : "password"
                                                                  : "text"
                                                              }
                                                              className="form-control form-control-sm shadow-sm border-0"
                                                              value={
                                                                formData[key]
                                                              }
                                                              onChange={(e) =>
                                                                handleInputChange(
                                                                  key,
                                                                  e.target.value
                                                                )
                                                              }
                                                              style={{
                                                                fontSize:
                                                                  "0.8rem",
                                                                backgroundColor:
                                                                  "#f8f9fa",
                                                                borderRadius:
                                                                  "6px",
                                                                padding:
                                                                  "0.375rem 0.75rem",
                                                                paddingRight:
                                                                  isPasswordField
                                                                    ? "40px"
                                                                    : "32px",
                                                                height: "32px",
                                                              }}
                                                            />
                                                            {isPasswordField ? (
                                                              <button
                                                                type="button"
                                                                className="btn btn-sm position-absolute"
                                                                style={{
                                                                  right: "4px",
                                                                  width: "28px",
                                                                  height:
                                                                    "24px",
                                                                  display:
                                                                    "flex",
                                                                  justifyContent:
                                                                    "center",
                                                                  alignItems:
                                                                    "center",
                                                                  background:
                                                                    "transparent",
                                                                  border:
                                                                    "none",
                                                                  padding: 0,
                                                                  cursor:
                                                                    "pointer",
                                                                }}
                                                                onClick={() =>
                                                                  isPassword
                                                                    ? setShowPassword(
                                                                        !showPassword
                                                                      )
                                                                    : setShowClientSecret(
                                                                        !showClientSecret
                                                                      )
                                                                }
                                                              >
                                                                {isPassword &&
                                                                  (showPassword ? (
                                                                    <FiEyeOff
                                                                      size={14}
                                                                    />
                                                                  ) : (
                                                                    <FiEye
                                                                      size={14}
                                                                    />
                                                                  ))}
                                                                {isClientSecret &&
                                                                  (showClientSecret ? (
                                                                    <FiEyeOff
                                                                      size={14}
                                                                    />
                                                                  ) : (
                                                                    <FiEye
                                                                      size={14}
                                                                    />
                                                                  ))}
                                                              </button>
                                                            ) : (
                                                              <FiEdit3
                                                                size={12}
                                                                className="position-absolute text-muted"
                                                                style={{
                                                                  right: "8px",
                                                                  pointerEvents:
                                                                    "none",
                                                                  opacity: 0.9,
                                                                }}
                                                              />
                                                            )}
                                                          </div>
                                                          {isRequired &&
                                                            formData[key] ===
                                                              "" && (
                                                              <div className="invalid-feedback d-block mt-1 small">
                                                                {key} ne peut
                                                                pas être vide
                                                              </div>
                                                            )}
                                                        </Col>
                                                      </Row>
                                                    </div>
                                                  );
                                                }
                                              )}
                                            </div>
                                          </CardBody>
                                        </Collapse>
                                      </Card>
                                    </Row>
                                  ) : null}
                                </Col>
                              </Col>
                            </Row>
                          </>
                        ) : (
                          <Spinners setLoading={setLoading} setWait={wait} />
                        )}
                      </div>
                    )}
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </div>
        </div>
        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default NewConfigMessagerie;
